"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var EventQueue = function () {
  function EventQueue() {
    (0, _classCallCheck2["default"])(this, EventQueue);
    (0, _defineProperty2["default"])(this, "queue", []);
  }

  (0, _createClass2["default"])(EventQueue, [{
    key: "addEventToQueue",
    value: function addEventToQueue(event) {
      this.queue.push(event);
    }
  }, {
    key: "addEventToTopOfQueue",
    value: function addEventToTopOfQueue(event) {
      this.queue.unshift(event);
    }
  }, {
    key: "playQueueEvents",
    value: function playQueueEvents() {
      var length = this.queue.length;
      this.queue.forEach(function (event) {
        return event();
      });
      this.queue = this.queue.slice(length);
    }
  }]);
  return EventQueue;
}();

var _default = EventQueue;
exports["default"] = _default;
//# sourceMappingURL=EventQueue.js.map